import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import bootstrapPlugin from '@fullcalendar/bootstrap';

// Calendars are rebuilt on every turbo:load. Keep the live instances here so they
// can be destroyed before Turbo snapshots the page -- otherwise a back/forward visit
// restores markup that already holds a rendered calendar and we render a second one
// into the same container.
let calendars = [];

const build_multi_calendar = () => {
  let calendar = new Calendar(document.getElementById('multi-calendar'), {
    plugins: [ resourceTimelinePlugin, bootstrapPlugin],
    themeSystem: 'bootstrap',
    defaultView: 'resourceTimelineWeek',
    slotDuration: { days: 1},
    snapDuration: '06:00:00',
    header: {
      left: 'today prev,next',
      center: 'title',
      right: 'resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth'
    },
    resourceAreaWidth: "15%",
    resourceLabelText: 'Availability',
    resourceGroupField: 'city',
    resources: 'accommodations.json',
    events:  'bookings.json',
    close: 'fa-times',
    prev: 'fas fa-chevron-left',
    next: 'fc-icon fc-icon-chevron-right',
    prevYear: 'fa-angle-double-left',
    nextYear: 'fa-angle-double-right'
  })
  calendar.render();
  calendars.push(calendar);
};

const build_single_calendar = (el) => {
  let calendar = new Calendar(el ,{
    plugins: [ dayGridPlugin ],
    defaultView: 'dayGridMonth',
    header: {
      left: 'prev,next',
      center: 'title',
      right: 'month,listMonth'
    },
    events: el.getAttribute('data-url')
  })
  calendar.render();
  calendars.push(calendar);
}

document.addEventListener("turbo:load", function() {
  if (document.getElementById('multi-calendar')) {
    build_multi_calendar();
  }
  let el = document.getElementById('single-calendar')
  if (el) {
    build_single_calendar(el);
  }
})

document.addEventListener("turbo:before-cache", function() {
  calendars.forEach((calendar) => calendar.destroy());
  calendars = [];
})
